import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    width: '100%'
  },
  sectionTitle: {
    fontSize: 16,
    color: theme.colorPalette.beige_60,
    fontWeight: 400,
    margin: theme.spacing(3, 0, 4, 0)
  },
  subtitleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginBottom: theme.spacing(1)
  },
  sectionSubtitle: {
    fontSize: 10,
    fontWeight: 600,
    textTransform: 'uppercase',
    color: theme.colorPalette.beige_60,
    margin: 0
  },
  totalLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  totalText: {
    fontSize: 10,
    fontWeight: 600,
    color: theme.colorPalette.beige_60
  },
  totalCount: {
    fontSize: 10,
    color: theme.colorPalette.white_30,
    fontWeight: 600
  },
  bannerContainer: {
    width: '100%',
    padding: theme.spacing(2),
    backgroundColor: theme.colorPalette.green_75_40,
    borderRadius: theme.sizes.roundCorners,
    margin: theme.spacing(1.25, 0)
  },
  noItemsBanner: {
    textAlign: 'center',
    color: theme.colors.white
  },
  noItemsTitle: {
    fontSize: 14,
    fontWeight: 'normal',
    margin: theme.spacing(1, 0),
    color: theme.colorPalette.beige_10
  },
  noItemsSubtitle: {
    fontSize: 10,
    margin: theme.spacing(0.5, 0),
    color: theme.colorPalette.white_30
  },
  searchContainer: {
    width: '100%',
    backgroundColor: theme.colorPalette.green_20
  },
  addFormContainer: {
    width: '100%',
    margin: theme.spacing(2, 0),
    border: `2px solid ${theme.colorPalette.green_15}`,
    borderRadius: theme.sizes.roundCorners,
    padding: theme.spacing(4, 8)
  },
  description: {
    marginTop: theme.spacing(-3)
  },
  singleBottom: {
    marginTop: theme.spacing(2),
    justifyContent: 'flex-end'
  },
  propertyFormContainer: {
    marginTop: theme.spacing(3)
  },
  gridContainer: {
    width: '100%'
  },
  gridItem: {
    paddingRight: 0,
    '&:first-of-type': {
      paddingTop: 0
    }
  },
  relativeGridItem: {
    paddingRight: 0,
    position: 'relative'
  },
  propertyItem: {
    backgroundColor: theme.colorPalette.green_15,
    padding: theme.spacing(2, 4),
    borderBottom: `0.5px solid ${theme.colorPalette.beige_10_op_75}`,
    width: '100%',
    '&:first-of-type': {
      borderTopLeftRadius: theme.sizes.roundCorners,
      borderTopRightRadius: theme.sizes.roundCorners
    },
    '&:last-of-type': {
      borderBottomLeftRadius: theme.sizes.roundCorners,
      borderBottomRightRadius: theme.sizes.roundCorners,
      borderBottom: 'none'
    }
  },
  propertyContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  propertyInfo: {
    flex: 1
  },
  propertyTitle: {
    fontSize: 14,
    fontWeight: 400,
    margin: '0 0 4px 0',
    color: theme.colorPalette.beige_10
  },
  propertyAddress: {
    fontSize: 10,
    fontWeight: 600,
    margin: 0,
    color: theme.colorPalette.beige_10,
    textTransform: 'uppercase'
  },
  deleteButton: {
    color: theme.colorPalette.orange_50
  },
  deleteIcon: {
    color: 'inherit',
    width: 16,
    height: 16
  },
  tooltipFieldLabel: {
    position: 'absolute',
    right: 0,
    top: 0
  }
});

export default makeStyles(styles);
